/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type ConversationErrorStatusFilterConfigColumn =
  (typeof ConversationErrorStatusFilterConfigColumn)[keyof typeof ConversationErrorStatusFilterConfigColumn];

export const ConversationErrorStatusFilterConfigColumn = {
  conversation_error_status: 'conversation_error_status',
} as const;
